// extracted by mini-css-extract-plugin
module.exports = {"root":"tXScnxufMUimOLlknvIk","disabled":"aOzE44sb1eMalypo7a7L"};